import { MemberEntryModal } from '@library/components/modals/MemberEntryModal';
import { selectMemberActionsAccessPermissions } from '@bo-selectors/members/memberActionPermissions';
import { useMemberEntryDetails } from '@bo-hooks/members';
import { useSelector } from 'react-redux';

export interface MemberEntryDetailsProps {
  entryId: string;
  memberId: string;
  onClose: () => void;
}

export const MemberEntryDetails = ({
  entryId,
  memberId,
  onClose
}: MemberEntryDetailsProps) => {
  const { newWager, isError, isLoading } = useMemberEntryDetails({
    entryId,
    memberId
  });

  const { hasAccessMemberRefundEntry } = useSelector(
    selectMemberActionsAccessPermissions
  );

  return (
    <MemberEntryModal
      canRefundEntry={hasAccessMemberRefundEntry}
      isError={isError}
      isLoading={isLoading}
      isOpen
      selectedNewWager={newWager}
      onCancelModal={onClose}
    />
  );
};
